// Order-details helpers (ported from old `utils/document-check-utils.ts` +
// `utils/orderDetails.ts`).

import type { IApiFieldMatch } from '@/api/certified-materials/types';
import type { IDocumentContentCheck, IVerificationField } from '../-types';

export function formatAddress(
  address?: string | null,
  city?: string | null,
  postCode?: string | null,
  country?: string | null,
): string {
  return [address, city, postCode, country].filter(Boolean).join(', ');
}

export function transformFieldMatchesToDocumentCheck(
  fieldMatches: IApiFieldMatch[],
): IDocumentContentCheck {
  const documents = fieldMatches.map(match => ({
    id: match.id,
    documentName: match.fileName,
    documentType: match.documentType,
    companyName: '',
    hasIssues: match.status === 'error',
    verificationFields: match.fields.map(
      (field): IVerificationField => ({
        name: field.label,
        fieldKey: field.field,
        status:
          field.status === 'valid'
            ? 'match'
            : field.status === 'needs_review'
              ? 'needs_review'
              : field.status === 'skipped'
                ? 'skipped'
                : 'mismatch',
        expectedValue: field.expected,
        extractedValue: field.actual,
        reasoning: field.reasoning,
        isManuallyValidated: field.isManuallyValidated ?? false,
        validatedByUserName: field.validatedByUserName ?? null,
        validatedAt: field.validatedAt ?? null,
      }),
    ),
    comments: match.comments,
  }));

  const documentsWithMismatches = documents.filter(d => d.hasIssues).length;
  const documentsMatching = documents.length - documentsWithMismatches;

  return {
    status:
      documents.length === 0
        ? 'pending'
        : documentsWithMismatches > 0
          ? 'needs_review'
          : 'approved',
    received: documents.length,
    total: documents.length,
    documentsWithMismatches,
    documentsMatching,
    documents,
  };
}
